/* JR: Floating "Need help selecting a product?" tab that opens a slide-out panel
   with the RIF tool. Ported from Debut, delivered site-wide as an asset so it loads
   on every page. Self-contained: injects its own styles, markup, and behavior.
   The tool URL comes from window.JR_RIF_URL, which meta-tags.liquid sets from the
   settings.rif_tool_url theme setting (single source of truth). */
(function () {
  var TOOL_URL = (window.JR_RIF_URL && String(window.JR_RIF_URL)) || '';

  function init() {
    if (document.getElementById('custom-floating-wrapper')) return;
    if (!TOOL_URL) return; // no configured RIF URL — nothing to open

    // Styles
    var css = [
      '#floating-tab{position:fixed;right:0;top:35%;transform:translateY(-35%);',
      'background-color:#3f94ec;color:#fff;border:solid 1px rgba(0,0,0,.5);',
      'padding:12px 6px;cursor:pointer;z-index:999999;border-radius:4px 0 0 4px;',
      'box-shadow:-2px 2px 10px rgba(0,0,0,0.2);}',
      '#floating-tab span{writing-mode:vertical-rl;text-transform:capitalize;',
      'font-weight:bold;letter-spacing:1px;font-size:14px;padding:5px 8px;',
      "font-family:arial,helvetica,sans-serif;}",
      '#slideout-panel{position:fixed;right:-650px;top:0;width:600px;height:100vh;',
      'background:#fff;box-shadow:-5px 0 25px rgba(0,0,0,0.3);',
      'transition:right 0.4s ease-in-out;z-index:1000000;display:flex;flex-direction:column;}',
      '#slideout-panel.is-open{right:0;}',
      '#close-panel-btn{background:#3b60a3;color:#fff;border:none;padding:11px 15px 12px;',
      'cursor:pointer;font-size:16px;font-weight:bold;',
      "font-family:arial,helvetica,sans-serif;text-align:right;}",
      '#iframe-container{flex-grow:1;width:100%;height:100%;}',
      '#iframe-container iframe{width:100%;height:100%;border:none;}',
      '@media (max-width:600px){',
      '#floating-tab{right:0;top:auto;bottom:0;transform:none;width:100%;',
      'padding:10px 4px;border-radius:0;box-shadow:0 -2px 10px rgba(0,0,0,0.15);}',
      '#floating-tab span{writing-mode:horizontal-tb;display:block;text-align:center;font-size:14px;}',
      '#slideout-panel{width:100%;right:-100%;}',
      '#slideout-panel.is-open{right:0;}',
      '}'
    ].join('');
    var style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);

    // Markup
    var wrapper = document.createElement('div');
    wrapper.id = 'custom-floating-wrapper';
    wrapper.innerHTML =
      '<button id="floating-tab" aria-label="Need help selecting a product?" aria-haspopup="dialog" aria-expanded="false" aria-controls="slideout-panel"><span>Need help selecting a product?</span></button>' +
      '<div id="slideout-panel" role="dialog" aria-modal="true" aria-label="Product selection tool" aria-hidden="true">' +
      '<button id="close-panel-btn" aria-label="Close">&times; Close</button>' +
      '<div id="iframe-container"></div></div>';
    document.body.appendChild(wrapper);

    var tab = document.getElementById('floating-tab');
    var panel = document.getElementById('slideout-panel');
    var closeBtn = document.getElementById('close-panel-btn');
    var iframeContainer = document.getElementById('iframe-container');
    var lastFocused = null;

    function openPanel() {
      lastFocused = document.activeElement;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      tab.setAttribute('aria-expanded', 'true');
      if (!iframeContainer.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', TOOL_URL);
        iframe.setAttribute('title', 'Joist Repair Tool');
        iframeContainer.appendChild(iframe);
      }
      // move keyboard focus into the panel
      setTimeout(function () { closeBtn.focus(); }, 0);
    }
    function closePanel() {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      tab.setAttribute('aria-expanded', 'false');
      // restore focus to the button that opened the panel
      if (lastFocused && typeof lastFocused.focus === 'function') { lastFocused.focus(); }
      else { tab.focus(); }
    }

    tab.addEventListener('click', function (e) { e.stopPropagation(); openPanel(); });
    closeBtn.addEventListener('click', closePanel);
    document.addEventListener('click', function (event) {
      if (!panel.contains(event.target) && !tab.contains(event.target) && panel.classList.contains('is-open')) {
        closePanel();
      }
    });
    // Escape closes; Tab is kept inside the panel (close button is the only in-page control; the iframe holds the rest)
    document.addEventListener('keydown', function (event) {
      if (!panel.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); closePanel(); return; }
      if (event.key === 'Tab' && !panel.contains(document.activeElement)) {
        event.preventDefault();
        closeBtn.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
